import ReactDOM from 'react-dom'
import cx from 'classnames'
import { PropsWithChildren } from 'react'

const ConfirmBox = ({
  isActive,
  className,
  compact,
  children,
  zIndex,
  disabled,
}: PropsWithChildren<{
  isActive: boolean
  className?: string
  compact?: boolean
  zIndex?: number
  disabled?: boolean
}>) => {
  return ReactDOM.createPortal(
    <div
      style={{ zIndex }}
      className={cx('ConfirmBox', {
        'ConfirmBox--active': isActive,
        'ConfirmBox--compact': compact,
        'ConfirmBox--disabled': disabled,
        [className]: className,
      })}
    >
      {children}
    </div>,
    document.querySelector('#confirmBoxes')
  )
}

export default ConfirmBox
